import { useState, useEffect } from 'react';
import { startRecording, stopRecording } from '../../api/fetchRecording';
import { useParams } from 'react-router';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { IconButton } from '@material-ui/core';
import styles from './styles';
import Tooltip from '@material-ui/core/Tooltip';

export default function RecordingButton({ classes, room }) {
  const [isRecording, setRecording] = useState(false);
  const [archiveId, setArchiveId] = useState(null);
  const localClasses = styles();
  let { pid } = useParams();
  const handleRecordingStart = async (sessionId) => {
    try {
      const data = await startRecording(sessionId);
      if (data.status === 200) {
        if (data.data) {
          const { archiveId } = data.data;
          sessionStorage.setItem('archiveId', archiveId);
          setArchiveId(archiveId);
          await postArchiveId(archiveId);
        }
        setRecording(true);
      }
    } catch (e) {
      console.error('Error starting recording:', e);
      setRecording(false);
    }
  };

  const postArchiveId = async (archiveId) => {
    try {
      const userData = JSON.parse(sessionStorage.getItem('userData'));
      const postData = { archiveId, livemeetingId: room.roomId }; // Assuming your API expects { archiveId } as data
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/v2/video/media/archive/${pid}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${userData?.token}`,
          },
          body: JSON.stringify(postData),
        }
      );

      if (response.ok) {
        console.log('Archive ID posted successfully');
      } else {
        console.error('Failed to post archive ID');
      }
    } catch (error) {
      console.error('Error posting archive ID:', error);
    }
  };
  useEffect(() => {
    window.addEventListener('message', function (e) {
      const jsonParse = JSON.parse(e.data);

      if (jsonParse.action == 'startRecordingSignal') {
        const startButton = document.getElementById('recordingId');
        if (startButton) {
          startButton.click();
        }
        // handleRecordingAction();
      }
      if (jsonParse.action == 'stopRecordingSignal') {
        const startButton = document.getElementById('recordingId');
        if (startButton) {
          startButton.click();
        }
        // handleRecordingAction();
      }
    });
  }, []);

  useEffect(() => {
    window.addEventListener('message', function (e) {
      const jsonParse = JSON.parse(e.data);
      if (jsonParse.action == 'endlivemeeting' && isRecording) {
        handleRecordingAction();
      }
    });
  }, []);

  const handleRecordingStop = async (archiveId) => {
    try {
      if (isRecording) {
        const data = await stopRecording(
          archiveId ? archiveId : sessionStorage.getItem('archiveId')
        );
        if (data.status === 200 && data.data) {
          const { status } = data.data;
          setRecording(false);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleRecordingAction = () => {
    if (room) {
      const sessionId = room.roomId;
      isRecording
        ? handleRecordingStop(archiveId)
        : handleRecordingStart(sessionId);
    }
  };

  const title = isRecording ? 'Stop Recording' : 'Start Recording';

  return (
    <Tooltip title={title} aria-label='add'>
      <IconButton
        edge='start'
        color='inherit'
        aria-label='mic'
        onClick={handleRecordingAction}
        className={classes.toolbarButtons}
        id='recordingId'
      >
        {isRecording ? (
          <FiberManualRecordIcon
            fontSize='inherit'
            className={localClasses.activeRecordingIcon}
            style={{ color: '#D50F2C' }}
          />
        ) : (
          <FiberManualRecordIcon fontSize='inherit' />
        )}
      </IconButton>
    </Tooltip>
  );
}
